import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQuery } from 'react-query'

export const useCustomerInvoices = () => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery(['workspaces', workspaceId, 'customerInvoices'], async () => {
    const res = await WorkspaceClient.getCustomerInvoices(workspaceId)

    if (res.type !== SUCCESS_RESPONSE_TYPE) {
      throw new Error('Failed to fetch customer invoices')
    }

    return res.data.customer_invoices
  })
}
